import React from "react";
import { useField } from "formik";
import { FieldRenderers } from "@avamae/formbuilder";

function ReadOnlySingleSelect(props: { isMulti?: boolean; name: string }) {
  const [field] = useField(props.name);

  if (Array.isArray(field.value)) {
    return (
      <input
        readOnly
        className="EditBox ViewOnly"
        value={field.value.join(", ")}
      />
    );
  } else {
    return <input readOnly className="EditBox ViewOnly" value={field.value} />;
  }
}

export const readOnlyFieldRenderer: FieldRenderers<any> = {
  singleselect: (i, field) => (
    <div key={i} className="FormBox FormSideBySide">
      <div className="FormLabel">
        <label>{field.label}</label>
      </div>
      <div className="FormField">
        <ReadOnlySingleSelect name={String(field.name)} />
      </div>
    </div>
  ),
  multiselect: (i, field) => (
    <div key={i} className="FormBox FormSideBySide">
      <div className="FormLabel">
        <label>{field.label}</label>
      </div>
      <div className="FormField">
        <ReadOnlySingleSelect name={String(field.name)} />
      </div>
    </div>
  ),
  file: (i, field) => (
    <div key={i} className="FormBox FormSideBySide">
      <div className="FormLabel">
        <label>{field.label}</label>
      </div>
      <div className="FormField">
        <div className="EditBox ViewOnly">-</div>
      </div>
    </div>
  ),
};
